module.exports = __webpack_public_path__ + "static/mercu_logo_full-3529fb4386919f93ee4aaca0332159d0.png";